import { DataSource, CollectionViewer } from "@angular/cdk/collections";
import { Observable, BehaviorSubject } from "rxjs";
import { BaseDataSource } from "../../../../../../utils/datasources/shared/base.datasource";
import { Injectable } from "@angular/core";

@Injectable()
export class FormTableDataSource<T> extends BaseDataSource<T> {
    data = new BehaviorSubject<T[]>([]);
    list = new Array<T>();

    constructor() {
        super(undefined);
    }

    connect(collectionViewer: CollectionViewer): Observable<T[]> {
        return this.data;
    }

    disconnect(collectionViewer: CollectionViewer): void {}

    show(data: Array<any>) {
        this.data.next(data);
    }

    addNewRecord(record) {
        if (this.list.includes(record)) {
            return;
        }

        this.list.push(<T>record);
        this.data.next(this.list);
    }

    setList(list) {
        this.list = list;
        this.data.next(this.list);
    }
}
